import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";
import { TutorialProvider } from "./lib/tutorial";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Tutorial from "./components/Tutorial";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import MagicLinkVerify from "./pages/MagicLinkVerify";
import Dashboard from "./pages/Dashboard";
import Workouts from "./pages/Workouts";
import Session from "./pages/Session";
import Exercises from "./pages/Exercises";
import ExerciseDetail from "./pages/ExerciseDetail";
import Education from "./pages/Education";
import EducationArticle from "./pages/EducationArticle";
import PreviousWorkouts from "./pages/PreviousWorkouts";
import Progress from "./pages/Progress";
import Ranks from "./pages/Ranks";
import Squad from "./pages/Squad";
import Nutrition from "./pages/Nutrition";
import Pricing from "./pages/Pricing";
import Admin from "./pages/Admin";
import Account from "./pages/Account";
import Welcome from "./pages/Welcome";
import ScrollToTop from "./components/ScrollToTop";
import InstallPrompt from "./components/InstallPrompt";

function Router() {
    const location = useLocation();
    // Handle Emergent Google OAuth callback: session_id in URL fragment
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <>
            <ScrollToTop />
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pricing" element={<Layout><Pricing /></Layout>} />

            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/auth/magic" element={<MagicLinkVerify />} />
            <Route path="/welcome" element={<ProtectedRoute requireOnboarding={false} requirePremium={false}><Welcome /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
            <Route path="/workouts" element={<ProtectedRoute><Layout><Workouts /></Layout></ProtectedRoute>} />
            <Route path="/session/:logId" element={<ProtectedRoute><Layout><Session /></Layout></ProtectedRoute>} />
            <Route path="/exercises" element={<ProtectedRoute><Layout><Exercises /></Layout></ProtectedRoute>} />
            <Route path="/exercises/:id" element={<ProtectedRoute><Layout><ExerciseDetail /></Layout></ProtectedRoute>} />
            <Route path="/education" element={<ProtectedRoute><Layout><Education /></Layout></ProtectedRoute>} />
            <Route path="/education/:slug" element={<ProtectedRoute><Layout><EducationArticle /></Layout></ProtectedRoute>} />
            <Route path="/previous" element={<ProtectedRoute><Layout><PreviousWorkouts /></Layout></ProtectedRoute>} />
            <Route path="/progress" element={<ProtectedRoute><Layout><Progress /></Layout></ProtectedRoute>} />
            <Route path="/ranks" element={<ProtectedRoute><Layout><Ranks /></Layout></ProtectedRoute>} />
            <Route path="/squad" element={<ProtectedRoute><Layout><Squad /></Layout></ProtectedRoute>} />
            <Route path="/nutrition" element={<ProtectedRoute><Layout><Nutrition /></Layout></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute requirePremium={false}><Layout><Account /></Layout></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireOnboarding={false} adminOnly><Layout><Admin /></Layout></ProtectedRoute>} />
        </Routes>
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <ThemeProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <TutorialProvider>
                            <Router />
                            <InstallPrompt />
                            <Tutorial />
                            <Toaster richColors theme="dark" />
                        </TutorialProvider>
                    </AuthProvider>
                </BrowserRouter>
            </ThemeProvider>
        </div>
    );
}
